import {
  AboutUsHeroSection,
  AboutUsOurSectorsSection,
  LeadershipSection,
  VisionMissionValuesSection,
} from "@modules/about-us/components";
import { AboutUsData } from "@modules/about-us/data/mockData";

type AboutUsPageProps = {
  data: AboutUsData;
};

export function AboutUsPage({ data }: AboutUsPageProps) {
  return (
    <div>
      <AboutUsHeroSection />
      <AboutUsOurSectorsSection />
      <VisionMissionValuesSection data={data} />
      <LeadershipSection data={data} />
    </div>
  );
}
